__turbopack_context__.v({
  "activePanel": "faq-module-scss-module__9X75Ra__activePanel",
  "arrowWrapper": "faq-module-scss-module__9X75Ra__arrowWrapper",
  "faqWrp": "faq-module-scss-module__9X75Ra__faqWrp",
  "header": "faq-module-scss-module__9X75Ra__header",
  "panel": "faq-module-scss-module__9X75Ra__panel",
  "panelContent": "faq-module-scss-module__9X75Ra__panelContent",
  "panelGroup": "faq-module-scss-module__9X75Ra__panelGroup",
  "panelHeader": "faq-module-scss-module__9X75Ra__panelHeader",
  "panelIcon": "faq-module-scss-module__9X75Ra__panelIcon",
  "questionIcon": "faq-module-scss-module__9X75Ra__questionIcon",
});
